import styled from 'styled-components';

import {COLOR, DIMENSION} from '../../constants';

export const CourseModuleContainer = styled.div`
  background-color: var(--admin-body-color);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 0 25px;
  overflow: hidden;
  padding: 0 5px 15px;
  padding-top: calc(1vw + 100px);
  position: relative;
  margin: 0 0 2vh 0;
  &.clean-top {
    padding: 15px;
  }
  &.add-new {
    background-color: #add0ff88;
    cursor: pointer;
    border: 1px dashed #cccccc;
  }
`;

export const CourseModuleContainerHead = styled.div`
  background: var(--admin-secondary-color);
  cursor: grab;
  left: 0;
  padding: 5px;
  padding-left: 20px;
  position: absolute;
  right: 0;
  top: 0;
  input {
    background-color: transparent !important;
    border-bottom: 1px solid #ccc !important;
  }
  &:before {
    color: rgba(34, 134, 168, 0.4);
    cursor: grab;
    content: '\f58e';
    font-family: 'Font Awesome 6 Pro';
    left: 10px;
    margin-top: -10px;
    position: absolute;
    top: 50%;
  }
`;

export const CourseModuleContentEmpty = styled.div`
  color: #777777;
  font-size: 1.33em;
  text-align: center;
  &:before {
    content: '\f067';
    font-family: 'Font Awesome 6 Pro';
    margin-right: 10px;
  }
`;

export const CourseModuleContainerMinified = styled.div`
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 20%) 0 0 4px;
  color: #cccccc;
  cursor: pointer;
  font-size: 1.33em;
  height: 30px;
  text-align: center;
  width: 100%;
`;
